import {Guess} from "@/models/Guess";
import {Actual} from "@/models/Actual";
import {Type} from "class-transformer";

export class Round {
    @Type(() => Guess)
    private guesses: Guess[] = [];

    @Type(() => Actual)
    private actuals: Actual[] = [];


    getGuesses() {
        return this.guesses;
    }

    setGuess(index: number, guess: number) {
        this.guesses[index] = new Guess(guess);
    }

    getActuals() {
        return this.actuals;
    }

    setActual(index: number, actual: number) {
        this.actuals[index] = new Actual(actual);
    }

}